import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { SelectStoreLanguageComponent } from './components/select-store-language/select-store-language.component';
import { MarketCategoryRepository } from './services/category.repository';
import { MarketService } from './services/market.service';
import { MarketEffects } from './store/market.effects';
import { MarketReducer } from './store/market.reducer';

@NgModule({
    declarations: [SelectStoreLanguageComponent],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        StoreModule.forFeature('market', MarketReducer),
        EffectsModule.forFeature([MarketEffects]),
    ],
    providers: [
        MarketCategoryRepository,
        MarketService,
    ],
    exports: [SelectStoreLanguageComponent],
})
export class MarketModule {}
